export const Keys = {
  ESC: `Esc`,
  ESCAPE: `Escape`,
};

export const SELECTORS = [
  {
    type: `tree`,
    weight: 5,
  },
  {
    type: `snowflake`,
    weight: 5,
  },
  {
    type: `ball`,
    weight: 5,
  },
  {
    type: `deer`,
    weight: 5,
  },
  {
    type: `snowman`,
    weight: 5,
  },
  {
    type: `boot`,
    weight: 5,
  },
  {
    type: `staff`,
    weight: 5,
  },
  {
    type: `bell`,
    weight: 5,
  },
];
